import { Pipe, PipeTransform } from '@angular/core';
import { ReferenceDataService } from '../services/reference-data.service';

@Pipe({ name: 'localizeLabel' })
export class LocalizeLabelPipe implements PipeTransform {
  constructor(private referenceDataService: ReferenceDataService) {}

  transform(id: string, ...args: Array<any>): string {
    let label = this.referenceDataService.getLocalizeLabel(id);

    args.forEach((arg: any, index: number) => {
      label = label.replace(`{${index}}`, arg);
    });

    return label;
  }
}
